/**
 * Base mainnet USDC (Circle). Used as the platform payment token for escrow, DAO, and wallet flows.
 * https://basescan.org/token/0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913
 */
export const BASE_MAINNET_USDC_ADDRESS =
  "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";

export const USDC_DECIMALS = 6;
